import React from 'react';
import { Badge } from '.';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';
import s from './badge-tooltip.module.scss';

interface AriaSupportBadgeProps {
  showBorder?: boolean;
  size?: 'tiny' | 'small' | 'medium';
}

export function AriaSupportBadge({
  showBorder,
  size = 'tiny',
}: AriaSupportBadgeProps) {
  const { t } = useEssentials();

  return (
    <Badge
      skin="general"
      type="solid"
      dataHook="aria-support-badge"
      uppercase={false}
      showBorder={showBorder}
      size={size}
      tooltipContent={
        <Text
          size="small"
          weight="thin"
          // @ts-expect-error wds types are incompatible
          skin="light"
          className={s.tooltipText}
        >
          {t('aria.support.badge.tooltip')}
        </Text>
      }
    >
      <Box fontSize={size === 'medium' ? 'small' : 'tiny'}>
        {t('aria.support.badge')}
      </Box>
    </Badge>
  );
}
